module.exports = __webpack_public_path__ + "static/media/halloween6.ef943741.webp";